import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "item"]

  filter() {
    const query = this.queryTarget.value.toLowerCase().trim()

    this.itemTargets.forEach((item) => {
      const haystack = item.dataset.resourceFilterName || item.textContent.toLowerCase()
      item.classList.toggle("hidden", query.length > 0 && !haystack.includes(query))
    })
  }
}
